var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import HeaderStyle from './HeaderStyle';
import HeaderWrapperStyle from './HeaderWrapperStyle';
import HeaderLogoText from './HeaderLogoText';
import HeaderNavigation from './HeaderNavigation';
import HeaderLinks from './HeaderLinks';
import AmsterdamLogo from '../AmsterdamLogo';
const Header = (_a) => {
    var { css, title, homeLink, fullWidth, tall, navigation, links, logo } = _a, otherProps = __rest(_a, ["css", "title", "homeLink", "fullWidth", "tall", "navigation", "links", "logo"]);
    return (React.createElement(HeaderWrapperStyle, Object.assign({}, { css, tall }, { id: "header" }),
        React.createElement(HeaderStyle, Object.assign({}, Object.assign({ fullWidth }, otherProps)),
            React.createElement(HeaderLogoText, Object.assign({}, { tall, title, homeLink, logo })),
            React.createElement(HeaderNavigation, null, navigation),
            React.createElement(HeaderLinks, null, links))));
};
Header.defaultProps = {
    tall: false,
    fullWidth: true,
    logo: AmsterdamLogo,
};
export default Header;
//# sourceMappingURL=Header.js.map